import { supabase } from "@/lib/supabase/browser-client"
import { SettingsState } from "@/lib/settings/settings-state"
import { ContentType } from "@/types/base"
import { createClientLogger } from "@/utils/logger/clientLogger"

const logger = createClientLogger('utility.listSorter', supabase)

export const getSortedData = (
	userSettings: SettingsState | null,
	contentType: ContentType | "workspaces",
	data: any
) => {
	if (userSettings) {
		const sortMode = userSettings.content[contentType].sort.mode
		const sortOrder = userSettings.content[contentType].sort.order

		if (sortMode == 'alpha') {
			const sorted = [...data].sort((a, b) => {
				if (sortOrder === 'asc') {
					return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
				} else {
					return b.name.localeCompare(a.name, undefined, { sensitivity: 'base' })
				}
			})
			return sorted
		}
		else if (sortMode == 'timestamp') {
			const sorted = [...data].sort((
				a: { updated_at: string; created_at: string },
				b: { updated_at: string; created_at: string }
			) => {
				if (sortOrder === 'asc') {
					return new Date(b.updated_at || b.created_at).getTime() -
							new Date(a.updated_at || a.created_at).getTime()
				}
				else {
					return new Date(a.updated_at || a.created_at).getTime() -
							new Date(b.updated_at || b.created_at).getTime()
				}
			})
			return sorted
		}
	}
	logger.info("No settings, not sorting data")
	return data
}
